import React, { useRef, useEffect } from 'react';
import { useLocation } from 'react-router';
import { AsideMenuMain } from './AsideMenuMain';
import { DrawerComponent, ScrollComponent, ToggleComponent } from '../../../assets/ts/components';
import useState from 'react-usestateref';

const AsideMenu = ({ asideMenuCSSClasses }) => {
  const [showLogout, setShowLogout, showLogoutref] = useState(false);
  const [tanentLogin, setTanentLogin, tanentLoginref] = useState(true);
  const { pathname } = useLocation();
  useEffect(() => {
    setTimeout(() => {
      DrawerComponent.reinitialization();
      ToggleComponent.reinitialization();
      ScrollComponent.reinitialization();

    }, 50);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);




  return (<div
    id="kt_aside_menu_wrapper"
    className="w-100 d-flex pe-2 force-scroll"
    data-kt-scroll="true"
    data-kt-scroll-activate="{default: false, lg: true}"
    data-kt-scroll-height="auto"
    data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
    data-kt-scroll-wrappers="#kt_aside, #kt_aside_menu, #kt_aside_menu_wrapper"
    data-kt-scroll-offset="100"
    style={{
      overflowY: 'scroll', // Always show vertical scrollbar
      maxHeight: '100vh', // Restrict height to viewport height
      scrollbarWidth: 'auto', // Ensure visible scrollbar in Firefox
      WebkitOverflowScrolling: 'touch', // Smooth scrolling for iOS
    }}
  >
    <div
      id="#kt_aside_menu"
      data-kt-menu="true"
      className="menu menu-column menu-rounded fw-bold my-auto"
    >
      <AsideMenuMain />
    </div>
  </div>);
};
export { AsideMenu };
